import { Component, input } from '@angular/core';

@Component({
  selector: 'app-chord-indicator',
  imports: [],
  templateUrl: './chord-indicator.component.html',
  styleUrl: './chord-indicator.component.scss',
})
export class ChordIndicatorComponent {
  public shortcutRows = input<{ key: string; label: string }[][]>([]);
  public shortcutPrefix = input<string>('');
}
